import React from 'react'

export const MagnifierWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 15.5L11.6556 12.1556M13.4444 7.72222C13.4444 11.1587 10.6587 13.9444 7.22222 13.9444C3.78578 13.9444 1 11.1587 1 7.72222C1 4.28578 3.78578 1.5 7.22222 1.5C10.6587 1.5 13.4444 4.28578 13.4444 7.72222Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
